import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";
import { Reveal, staggerParent, staggerChild } from "@/components/Motion";

export function readViews() {
  try { return JSON.parse(localStorage.getItem("vorra_views") || "[]"); } catch { return []; }
}

export function recordView(l) {
  const v = readViews().filter((x) => x.id !== l.id);
  v.unshift({ id: l.id, make: l.make, body: l.body_type, price: l.price });
  localStorage.setItem("vorra_views", JSON.stringify(v.slice(0, 20)));
}

export function RecommendedListings() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const v = readViews();
    const params = {
      makes: [...new Set(v.map((x) => x.make).filter(Boolean))].join(","),
      bodies: [...new Set(v.map((x) => x.body).filter(Boolean))].join(","),
    };
    if (v.length) params.price = Math.round(v.reduce((s, x) => s + (x.price || 0), 0) / v.length);
    api.get("/listings/recommended", { params }).then(({ data }) => setItems(data.items)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-24 lg:pt-32" data-testid="recommended-listings">
      <Reveal><span className="text-xs uppercase tracking-widest font-semibold text-teal">Recommended for you</span>
        <h2 className="font-heading font-extrabold text-navy tracking-tighter text-3xl sm:text-4xl mt-2">Picked from what you browse</h2></Reveal>
      <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((l) => <motion.div key={l.id} variants={staggerChild}><ListingCard listing={l} /></motion.div>)}
      </motion.div>
    </section>
  );
}
